/**
 * PhotoIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const PhotoIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M10 9a2 2 0 1 1-4 0 2 2 0 0 1 4 0" />
    <path
      fillRule="evenodd"
      d="M4 3h16a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2m16 10.59V5H4v9.59l1.23-1.24a2.52 2.52 0 0 1 3.54 0l.73.74 3.38-3.38a3 3 0 0 1 4.24 0zM4 17.41V19h16v-2.58l-4.29-4.3a1 1 0 0 0-1.42 0l-4.08 4.09a1 1 0 0 1-1.42 0l-1.44-1.44a.48.48 0 0 0-.7 0z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const PhotoIcon = makeIcon('PhotoIcon', PhotoIconSvg)
